import { CabecalhoDePagina } from '../componentes/Superficie.tsx';
import { UsuariasEPermissoes } from '../componentes/UsuariasEPermissoes.tsx';

/**
 * A tela inteira de acessos.
 *
 * A operação chega pelo acordeão de Configurações; esta rota continua
 * existindo para quem tem o endereço, e é o mesmo conteúdo com cabeçalho.
 */
export function PaginaUsuarias(): React.JSX.Element {
  return (
    <section>
      <CabecalhoDePagina area="Administração" titulo="Usuárias" />
      <UsuariasEPermissoes />
    </section>
  );
}
